import axios from 'axios'
import qs from 'qs'
import { processBrowserNavigator } from '../../helpers/processBrowserNavigator'

export default {
  state: {
    selectedUserLocation: JSON.parse(localStorage.getItem('selectedUserLocation')),
    exactUserLocation: JSON.parse(localStorage.getItem('exactUserLocation')),
    isCityFromGeoSelected: false,
    geoConfig: window?.config ?? {},
    isGeoPopupShown: false,
    potentialUserCity: null,
    popularCities: null
  },
  getters: {
    getActualUserCity (state) {
      return state.selectedUserLocation || state.exactUserLocation
    },
    currentSessionHash () {
      const value = `; ${document.cookie}`
      const parts = value.split(`; session_hash=`)
      return parts.pop().split(';').shift()
    }
  },
  mutations: {
    SET_EXACT_USER_LOCATION (state, info) {
      localStorage.setItem('exactUserLocation', JSON.stringify({ ...info, date: new Date() }))
      state.exactUserLocation = info
    },
    SET_SELECTED_USER_GEO (state, info) {
      localStorage.setItem('selectedUserLocation', JSON.stringify({ ...info, date: new Date() }))
      state.selectedUserLocation = info
    },
    SET_IS_GEO_POPUP_SHOWN (state, bool) {
      state.isGeoPopupShown = bool
    },
    SET_CITY_FROM_GEO_SELECTED (state, bool) {
      state.isCityFromGeoSelected = bool
    },
    SET_POTENTIAL_USER_CITY (state, city) {
      state.potentialUserCity = city
    },
    SET_POPULAR_CITIES (state, arr) {
      state.popularCities = arr
    }
  },
  actions: {
    SET_EXACT_USER_GEO_FROM_GPS ({ commit, rootGetters, dispatch, state }, { coords }) {
      const { latitude, longitude, accuracy } = coords

      localStorage.setItem('exactUserLocation', JSON.stringify({ latitude, longitude, accuracy }))
      return new Promise(resolve => {
        axios.get(rootGetters.urlLanguagePrefix + '/location/', { params: { latitude, longitude } })
          .then(response => {
            if (response.data.city_list && response.data.city_list.length) {
              commit('SET_EXACT_USER_LOCATION', { ...response.data.city_list[0], source: 'gps', latitude, longitude })
            } else if (!response.data.city_list) {
              commit('SET_EXACT_USER_LOCATION', { ...state.geoConfig.user_ip_location, source: 'ip' })
              commit('SET_SELECTED_USER_GEO', { ...state.geoConfig.user_ip_location, source: 'ip' })
            }
            resolve(response.data)
          })
          .catch(() => {
            commit('SET_EXACT_USER_LOCATION', { ...state.geoConfig.user_ip_location, source: 'ip' })
            commit('SET_SELECTED_USER_GEO', { ...state.geoConfig.user_ip_location, source: 'ip' })
          })
      })
    },
    SEND_USER_CITY ({ commit, rootGetters, state }, cityId) {
      commit('SET_IS_GEO_POPUP_SHOWN', false)

      axios.post(rootGetters.urlLanguagePrefix + '/location/', qs.stringify({ city_id: cityId }))
        .then(response => {
          if (response.data.status === 'success') {
            commit('SET_SELECTED_USER_GEO', { ...response.data.city_location })
          }
        })
    },
    SET_SELECTED_USER_GEO_ACTION ({ commit }, info) {
      commit('SET_SELECTED_USER_GEO', info)
    },
    SET_CITY_FROM_GEO_SELECTED_ACTION ({ commit }, bool) {
      commit('SET_CITY_FROM_GEO_SELECTED', bool)
    },
    INIT_EXACT_USER_LOCATION ({ commit, state, dispatch }) {
      const prevGeo = state.exactUserLocation
      let minutesLeft
      if (prevGeo && prevGeo.date) {
        minutesLeft = Math.floor((Date.now() - Date.parse(prevGeo.date)) / 60000)
      }
      const isGeoExpired = minutesLeft > state.geoConfig.params?.['exact_user_location_ttl']

      if (!state.exactUserLocation || isGeoExpired || !state.exactUserLocation.date) {
        processBrowserNavigator((coords) => {
          dispatch('SET_EXACT_USER_GEO_FROM_GPS', coords)
            .then(() => dispatch('INIT_SELECTED_USER_GEO'))
        }, () => {
          localStorage.removeItem('exactUserLocation')

          commit('SET_EXACT_USER_LOCATION', { ...state.geoConfig?.['user_ip_location'], source: 'ip' })
          dispatch('INIT_SELECTED_USER_GEO')
        }, false, true)
      } else {
        dispatch('INIT_SELECTED_USER_GEO')
      }
    },
    INIT_SELECTED_USER_GEO ({ commit, getters, state }) {
      if (!state.selectedUserLocation) {
        localStorage.setItem('sessionHash', getters.currentSessionHash)
        commit('SET_SELECTED_USER_GEO', state.geoConfig.user_city_location || state.exactUserLocation)
      } else if (getters.currentSessionHash !== localStorage.getItem('sessionHash')) {
        localStorage.setItem('sessionHash', getters.currentSessionHash)
        if (state.selectedUserLocation.city_id !== state.exactUserLocation.city_id) {
          commit('SET_POTENTIAL_USER_CITY', state.exactUserLocation)
        } else if (state.geoConfig.user_city_location && state.selectedUserLocation.city_id !== state.geoConfig.user_city_location.city_id) {
          commit('SET_POTENTIAL_USER_CITY', state.geoConfig.user_city_location)
        }
        commit('SET_IS_GEO_POPUP_SHOWN', true)
      }
    }
  }
}
